/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';

import type { HomeownerAPIResponse, HomeownerInfoModifyParams } from 'hems/user';

export default class UserInfoService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** Home Owner 정보 수정 */
  modifyHomeownerAccountInfo = (
    homeownerId: string,
    userAccountInfo: HomeownerInfoModifyParams
  ): Promise<HomeownerAPIResponse> => {
    return this.patch<HomeownerAPIResponse>(apiWrapper.managerApiV1(`/homeowners/${homeownerId}`), userAccountInfo);
  };

  /** Home Owner 정보 삭제 */
  deleteHomeownerAccountInfo = (homeownerId: string): Promise<HomeownerAPIResponse> => {
    return this.delete<HomeownerAPIResponse>(apiWrapper.managerApiV1(`/homeowners/${homeownerId}`));
  };
}
